export function updateUrlParamEntry(urlSearchParamKey: string, urlSearchParamValue: string, urlParams: URLSearchParams) {
  const urlSearchParamUpper = urlSearchParamKey.toUpperCase();
  urlParams.forEach((_, key: string) => {
    if (urlSearchParamUpper === key.toUpperCase()) {
      urlParams.set(key, urlSearchParamValue);
      return;
    }
  })
}

export function getUrlParts(url: string) {
  var a = document.createElement('a');
  a.href = url;

  return {
      href: a.href,
      host: a.host,
      hostname: a.hostname,
      port: a.port,
      pathname: a.pathname,
      protocol: a.protocol,
      hash: a.hash,
      search: a.search
  };
}